<template>
  <div class="row no-gutters c514 p-2">

    <div class="col-md-3 col-3">
      <img :src="image" :alt="alt" class="img-fluid">
    </div>

    <div class="col-md-9 col-9 pt-1 p-2">
      <slot name="p-1"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'C514',
  props: {
    image: {
      default: 'https://picsum.photos/1920/1080',
    },
    alt: {
      default: 'mix it web'
    }
  }
};
</script>


<style scoped>
.bg-color {
  background-color: var(--light-teal) !important;
}

.link-img {
  text-decoration: none;
  color: var(--dark) !important;
}

.c514 img {
  transition: 0.3s;
  filter: brightness(0.5);
}

.c514 img:hover {
  transition: 0.3s all ease-in-out;
  filter: none;
}

</style>
